class VideoAlert {
    constructor(options) {
        let { alertStyle = {}, maskStyle = {} ,havePathElement = ".match-chosen-poster"} =
        options === undefined ? {} : options; //如果没有传入任何的内容，则将options设为undefined

        this.havePathElement = document.querySelectorAll(`${havePathElement}`);
        this.alertStyle = alertStyle;
        this.maskStyle = maskStyle;
        console.log(this.havePathElement);

        this.videoAlertElement = document.createElement("video");
        this.videoAlertElement.setAttribute("autoplay", "");
        this.videoAlertElement.setAttribute("loop", "");
        this.videoAlertElement.setAttribute("playsinline", "");
        this.videoAlertElement.setAttribute("muted", "");
        this.videoAlertElement.setAttribute("controls", "");
        this.videoAlertMask = document.createElement("div");
        this.videoAlertCtn = document.createElement("div");
        this.closeIcon = document.createElement("div");
        this.closeIcon.innerHTML = `
        <svg  width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="13" cy="13" r="12" stroke="#FFF" stroke-width="2"></circle>
        <line x1="8.7574" y1="8.75725" x2="17.2427" y2="17.2425" stroke="#FFF" stroke-width="2"></line>
        <line x1="17.2428" y1="8.7574" x2="8.75747" y2="17.2427" stroke="#FFF" stroke-width="2"></line>
        </svg>        
        `

        //为alert和mask设置初始的样式
        this.setStyle({
            display: "flex",
            width: "100vw",
            height: "100vh",
            position: "fixed",
            top: 0,
            visibility: "hidden",
            "align-items": "center",
            "justify-content": "center",
            "z-index":"999999",
            "flex-direction": "column",
        }, {
            "max-width": "800px",
            width:"100vw",
            // height: "400px",
            "z-index": "1",
        }, {
            width: "100%",
            height: "100%",
            position: "absolute",
            "background-color": "#0009",
        });

        this.setStyle({}, this.alertStyle, this.maskStyle);

        this.closeIcon.style.cssText = `
            margin-top: 24px;
            cursor: pointer;
            z-index:9;
        `

        
        this.videoAlertCtn.appendChild(this.videoAlertElement);
        this.videoAlertCtn.appendChild(this.closeIcon);
        this.videoAlertCtn.appendChild(this.videoAlertMask);

        window.document.body.appendChild(this.videoAlertCtn);

        for (let i = 0; i < this.havePathElement.length; i++) {
            this.havePathElement[i].onclick = () => {
                this.openAlert(this.havePathElement[i].getAttribute("data-video-src"))
            };
        }

        this.videoAlertMask.onclick = () => {
            this.closeAlert()
        }

        this.closeIcon.onclick = () => {
            this.closeAlert()
        }
    }

    openAlert(src) {
        window.document.body.style.overflow = "hidden";
        this.setStyle({
            visibility: "initial",
        }, {}, {

        });

        this.videoAlertElement.src = src
    }

    closeAlert() {
        window.document.body.style.overflow = "auto"
        this.setStyle({
            visibility: "hidden"
        })
        this.videoAlertElement.src = ""
    }

    //将传入的video弹窗、mask弹窗的对象转换为字符串，方便设置样式
    getStyle() {
        Object.defineProperty(this, "toString", {
            enumerable: false,
        });
        let styleString = [];
        for (const [key, value] of Object.entries(this)) {
            styleString = [...styleString, `${key}: ${value}`];
        }

        styleString = styleString.join(";");

        return styleString;
    }

    setStyle(ctnStyle = {}, alertStyle = {}, maskStyle = {}) {
        ctnStyle.toString = this.getStyle.bind(ctnStyle);
        alertStyle.toString = this.getStyle.bind(alertStyle);
        maskStyle.toString = this.getStyle.bind(maskStyle);

        // console.log(`${alertStyle}`);
        // console.log(`${maskStyle}`)
        this.videoAlertCtn.style.cssText += `
            ${ctnStyle}
        `;

        this.videoAlertElement.style.cssText += `
            ${alertStyle}
        `;
        this.videoAlertMask.style.cssText += `
        ${maskStyle}
    `;
    }
}

export default VideoAlert